import React from "react"
import DodonesResolverDay from "site/dodones_resolver/Day"
import BirlIndex from "site/birl/Index"
import { HashRouter } from 'react-router-dom'
import { Routes, Route } from 'react-router-dom'
import Menu from 'site/layout/Menu'
import BirlExercisesIndex from 'site/birl/exercises/Index'

export default () => {
  return <HashRouter>
           <div id="site">
             <Menu />
             <div className="flex-1 subtle-gray-transparent-box p-d fcol">
               <Routes>
                 <Route path="/" element={<DodonesResolverDay />} />
                 <Route path="/birl" element={<BirlIndex />} />
                 <Route path="/birl/exercises" element={<BirlExercisesIndex />} />
               </Routes>
             </div>
           </div>
         </HashRouter>
}
